import { createI18n } from 'vue-i18n'
import de from './locales/de.json'
import en from './locales/en.json'
import { useSettingsStore } from '@/stores/settingsStore'

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: {
    de,
    en
  }
})

// Funktion zum Ändern der Sprache
export const setLocale = (locale: string) => {
  i18n.global.locale.value = locale
  document.querySelector('html')?.setAttribute('lang', locale)
}

// Initialisiere die Sprache aus den Einstellungen
export const initializeLocale = () => {
  const settingsStore = useSettingsStore()
  setLocale(settingsStore.settings.language)
}

export default i18n 